import { useCallback } from "react";
import type { NavigateFunction, NavigateOptions, To } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useViewAs from "hooks/useViewAs";
import { withShell } from "utils/clientViewRoutes";

/**
 * Drop-in useNavigate that cannot leave the current shell.
 *
 * Every page mounted under /client-view/:userId gets this instead of
 * useNavigate, so a string target is prefixed centrally and no page has to
 * remember client view exists. Deltas and To objects pass straight through.
 */
export function useAppNavigate(): NavigateFunction {
  const navigate = useNavigate();
  const { basePath } = useViewAs();

  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      if (typeof to === "number") {
        navigate(to);
        return;
      }
      if (typeof to === "string") {
        navigate(withShell(basePath, to), options);
        return;
      }
      navigate(to, options);
    },
    [navigate, basePath],
  ) as NavigateFunction;
}

export default useAppNavigate;
